/** @format */
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { DowngradedService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';
import { UniversityService } from '../service/university.service';

@StaticMembers<DowngradedService>()
@Injectable({ providedIn: 'root' })
export class FeedbackFeatureToggleService {
    static downgrade: ServiceDowngradeMappings = {
        moduleName: 'sis-components.feedback.FeedbackFeatureToggleService',
        serviceName: 'feedbackFeatureToggleService',
    };

    private feedbackEnabled: Observable<boolean>;

    constructor(private readonly universityService: UniversityService) {}

    /**
     * Cached feedback feature toggle value.
     */
    getFeedbackEnabled(): Observable<boolean> {
        if (!this.feedbackEnabled) {
            this.feedbackEnabled = this.universityService.getCurrentUniversitySettings().pipe(
                map(settings => !!settings?.featureToggles?.feedbackEnabled),
                shareReplay(1),
            );
        }

        return this.feedbackEnabled;
    }
}
